"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PortfolioRepository {
    fetcherAmplify;
    constructor(fetcherAmplify) {
        this.fetcherAmplify = fetcherAmplify;
    }
    async findByCustomer(customer) {
        const response = await this.fetcherAmplify.get('/v1/portfolio', {
            queryStringParameters: {
                customerId: customer?.id,
                customerType: customer?.type,
                type: 'CUSTOMER_PORTFOLIO',
            },
        });
        return response || [];
    }
    async findByGoals(customer) {
        const response = await this.fetcherAmplify.get('/v1/portfolio', {
            queryStringParameters: {
                customerId: customer?.id,
                customerType: customer?.type,
                type: 'GOAL_PORTFOLIO',
            },
        });
        return response || [];
    }
    async findPortfolioHistory(portfolioId) {
        return this.fetcherAmplify.get(`/v1/portfolio/${portfolioId}/history`);
    }
}
exports.default = PortfolioRepository;
//# sourceMappingURL=PorfolioRepositoryImpl.js.map